import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Carrier from "./Carrier";
import AirportDeparture from "./AirportDeparture ";
import AirportDestination from "./AirportDestination ";
import TimeDeparture from "./TimeDeparture";
import TimeArrival from "./TimeArrival";
import { classList } from "@utils";

import DateArrival from "./DateArrival";
import DateDept from "./DateDept";
import { MdDelete } from "react-icons/md";

const FlightLegs = ({
  index,
  values,
  touched,
  errors,
  handleChange,

  tripType,
  arrayHelpers,
  setFieldValue,
  array,
}) => {
  return (
    <>
      {index > 0 && <hr />}
      <Row
        style={{
          //  backgroundColor: "#e4ffff"  ,
          marginBottom: 8,
        }}
      >
        {index != 0 && (
          <Col>
            <div style={{ fontSize: 15, fontWeight: "bold" }}>
              Stops -{index}
            </div>
          </Col>
        )}
        {/* disabled={index == array.length - 1 ? false : true} */}
        {index > 0 && (
          <Col xs="6">
            {index == array.length - 1 && (
              <div className="d-flex justify-content-end ">
                <Button
                  variant="danger"
                  type="button"
                  onClick={() => {
                    arrayHelpers.remove(index);
                  }}
                >
                  <MdDelete color="white" size={20} />
                </Button>
              </div>
            )}
          </Col>
        )}
      </Row>
      <Row>
        {/* <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label className="heading">
              Supplier<span className="text-danger">*</span>
            </Form.Label>
            <input
              className="form-control"
              type="text"
              placeholder=""
              name={`flightLegs.return[${index}].supplier`}
              value={values?.flightLegs?.return[index]?.supplier || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.supplier &&
            errors?.flightLegs?.return[index]?.supplier ? (
              <div className="error-label"></div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col> */}
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airlines<span className="text-danger">*</span>
            </Form.Label>

            <Carrier
              index={index}
              value={values?.flightLegs?.return[index]?.airline || ""}
              onChange={handleChange}
              touched={touched?.flightLegs?.return[index]?.airline}
              setFieldValue={setFieldValue}
            />

            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.airline &&
            errors?.flightLegs?.return[index]?.airline ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.airline}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Flight Number<span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Flight Number"
              name={`flightLegs.return[${index}].fN`}
              value={values?.flightLegs?.return[index]?.fN || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched.flightLegs?.return[index]?.fN &&
            errors?.flightLegs?.return[index]?.fN ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.fN}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              PNR<span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="PNR"
              name={`flightLegs.return[${index}].pnr`}
              value={values?.flightLegs?.return[index]?.pnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.pnr &&
            errors?.flightLegs?.return[index]?.pnr ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.pnr}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Departure<span className="text-danger">*</span>
            </Form.Label>

            <AirportDeparture index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched.flightLegs?.return[index]?.airportDepartureId &&
            errors?.flightLegs?.return[index]?.airportDepartureId ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.airportDepartureId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Airport Destination<span className="text-danger">*</span>
            </Form.Label>

            <AirportDestination index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.return &&
            touched.flightLegs.return[index]?.airportDestinationId &&
            errors?.flightLegs?.return &&
            errors.flightLegs.return[index]?.airportDestinationId ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.airportDestinationId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Departure Date<span className="text-danger">*</span>{" "}
            </Form.Label>
            <Row style={{ marginTop: -20, marginBottom: -20 }}>
              <DateDept
                index={index}
                values={values}
                handleChange={handleChange}
                touched={touched}
                errors={errors}
              />
            </Row>
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Arrival Date<span className="text-danger">*</span>
            </Form.Label>
            <Row style={{ marginTop: -20, marginBottom: -20 }}>
              <DateArrival
                index={index}
                values={values}
                handleChange={handleChange}
                touched={touched}
                errors={errors}
              />
            </Row>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Departure<span className="text-danger">*</span>
            </Form.Label>
            <TimeDeparture
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.departureTime &&
            errors?.flightLegs?.return[index]?.departureTime ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.departureTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">
              Time Arrival<span className="text-danger">*</span>
            </Form.Label>
            <TimeArrival
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.arrivalTime &&
            errors?.flightLegs?.return[index]?.arrivalTime ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.arrivalTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>

        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "12" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">GDS PNR</Form.Label>

            <input
              className="form-control"
              type="text"
              placeholder="GDS PNR"
              name={`flightLegs.return[${index}].gdsPnr`}
              value={values.flightLegs.return[index].gdsPnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.gdsPnr &&
            errors?.flightLegs?.return[index]?.gdsPnr ? (
              <div className="error-label">
                {errors?.flightLegs?.return[index]?.gdsPnr}{" "}
                {/* {values?.flightLegs?.return[index]?.gdsPnr} */}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default FlightLegs;
